import PropTypes from 'prop-types';
import media from '@activebrands/core-web/config/media';
import { styled } from '@activebrands/core-web/libs/styletron';
import { Dialog } from '@base-ui/react/dialog';
import Paragraph from 'components/text/Paragraph';

const Wrapper = styled('div', {
    position: 'relative',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '24px',

    [media.min['desktop.sm']]: {
        marginBottom: '0px',
    },
});

const PrimaryMenuHeading = ({ text = '', titleSelector }) => {
    return (
        <Wrapper>
            <Dialog.Title
                data-selector={titleSelector}
                id="navigation-title"
                render={
                    <Paragraph
                        $style={{ color: 'var(--color-text-subtle)' }}
                        fontKeys={['Miscellaneous/16_100_-1', null, 'Miscellaneous/12_100']}
                    />
                }
            >
                {text}
            </Dialog.Title>
        </Wrapper>
    );
};

PrimaryMenuHeading.propTypes = {
    text: PropTypes.string,
    titleSelector: PropTypes.string,
};

export default PrimaryMenuHeading;
